import { PersonaGiuridicaDTO } from "./persona-giuridica-dto";

export class EnteRichiedenteCauzioneDTO {
	personaGiuridica: PersonaGiuridicaDTO;
	codiceRegione: string;
}